<div *ngIf="formGroup && fields">
  <h4 class="fd-subtitle">Selecionar tipo de registro:</h4>
  <fd-radio-button [parentForm]="formGroup" [field]="fields.licenseTypeName"> </fd-radio-button>

  <fd-button fdSecondary [content]="'cancelar'" id="btnCancel" (trigger)="back()"> </fd-button>

  <fd-button [content]="'avançar'" id="btnNext" (trigger)="next()"> </fd-button>
</div>
